import Vue from 'vue';
import Router from 'vue-router';

import {
	AclRule
} from "vue-acl";

import themeConfig from "@/../siteThemeConfig.js";

Vue.use(Router);

var urlBasePath = '/';

const router = new Router({
	mode: 'history',
	base: urlBasePath,
	scrollBehavior () {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: '',
			component: () => import('@/layouts/full-page/SiteFullPage.vue'),
			children: [
				{
					path: '/callback',
					name: 'auth-callback',
					component: () => import('@/views/Callback.vue'),
					meta: {
						rule: new AclRule("public").generate(),
					}
				},
				/*{
					path: '/',
					name: 'page-index',
					component: () => import('@/views/pages/site/Site.vue'),
					meta: {
						rule: new AclRule("public").generate(),
					}
				},*/
				{
					path: '/favoritos',
					name: 'page-favoritos',
					component: () => import('@/views/pages/site/Favoritos.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Favoritos",
					}
				},
				{
					path: '/m/:token',
					name: 'page-view-email',
					component: () => import('@/views/pages/site/ViewEmail.vue'),
					props: true,
					meta: {
						rule: new AclRule("public").generate(),
						title: "Visualizar Email",
					}
				},
				{
					path: '/estatistica/:id',
					name: 'page-estatistica',
					component: () => import('@/views/pages/site/Estatistica.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Estatísticas",
					}
				},
				{
					path: '/precos',
					name: 'page-precos',
					component: () => import('@/views/pages/site/Precos.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Preços",
					}
				},
				{
					path: '/textos-legais',
					name: 'page-termos',
					component: () => import('@/views/pages/site/Termos.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Textos Legais",
					}
				},
				{
					path: '/regras-estilos',
					name: 'page-regraestilo',
					component: () => import('@/views/pages/site/RegraEstilo.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Regras de Estilos",
					}
				},
				{
					path: '/painel/cadastro/textoLegal/view',
					name: 'page-termos-view',
					component: () => import('@/views/pages/site/TermosView.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Visualizar Textos Legais",
					}
				},
				{
					path: '/painel/cadastro/textoEstilo/view',
					name: 'page-regraestilo-view',
					component: () => import('@/views/pages/site/RegraEstiloView.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Visualizar Regras de Estilos",
					}
				},
				{
					path: '/nova-conta',
					name: 'page-conta-criar',
					component: () => import('@/views/pages/site/conta/Criar.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Criar uma nova conta",
					}
				},
				{
					path: '/nova-conta/senha',
					name: 'page-conta-criar-senha',
					component: () => import('@/views/pages/site/conta/CriarSenha.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Criar uma nova conta",
					}
				},
				{
					path: '/anunciar',
					name: 'page-anunciar',
					component: () => import('@/views/pages/site/Anunciar.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Criar Anúncio",
					}
				},
				{
					path: '/conta/entrar',
					name: 'page-conta-login',
					component: () => import('@/views/pages/site/conta/Login.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Entrar - Painel de controle",
					}
				},
				{
					path: '/conta/recuperar-senha',
					name: 'page-conta-recuperar-senha',
					component: () => import('@/views/pages/site/conta/ResetarSenha.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: 'Recuperar Senha - Painel de controle',
					}
				},
				{
					path: '/conta/recuperar-senha-enviado',
					name: 'page-conta-redefinir-senha-enviado',
					component: () => import('@/views/pages/site/conta/ResetarSenhaEnviado.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: 'Recuperar Senha - Painel de controle',
					}
				},
				{
					path: '/conta/definir-senha/:token',
					name: 'page-conta-definir-senha',
					component: () => import('@/views/pages/site/conta/DefinirSenha.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: 'Definir Senha - Painel de controle',
					}
				},
				{
					path: '/conta/painel',
					name: 'page-conta-painel',
					component: () => import('@/views/pages/site/conta/Painel.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Painel de controle",
					}
				},
				{
					path: '/conta/mensagens/:tipo?',
					name: 'page-conta-mensagens',
					component: () => import('@/views/pages/site/conta/Mensagens.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Mensagens - Painel de controle",
					}
				},
				{
					path: '/conta/mensagem/:id',
					name: 'page-conta-mensagem',
					component: () => import('@/views/pages/site/conta/Mensagem.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Mensagem - Painel de controle",
					}
				},
				{
					path: '/conta/contatar',
					name: 'page-conta-contatar',
					component: () => import('@/views/pages/site/conta/Contatar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Contatar - Painel de controle",
					}
				},
				{
					path: '/conta/anunciar',
					name: 'page-conta-anunciar',
					component: () => import('@/views/pages/site/conta/Anunciar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Criar Anúncio",
					}
				},
				{
					path: '/conta/anuncios',
					name: 'page-conta-anuncio-lista',
					component: () => import('@/views/pages/site/conta/Anuncio/Lista.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Anúncios",
					}
				},
				{
					path: '/conta/anuncios/verificar',
					name: 'page-conta-anuncio-lista-verificar',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaVerificar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Verificar Anúncios",
					}
				},
				{
					path: '/conta/anuncio/:id/verificar',
					name: 'page-conta-anuncio-verificar',
					component: () => import('@/views/pages/site/conta/Anuncio/Verificar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Verificar Anúncio",
					}
				},
				{
					path: '/conta/anuncios/desativar',
					name: 'page-conta-anuncio-lista-desativar',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaDesativar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Desativar Anúncios",
					}
				},
				{
					path: '/conta/anuncio/:id/desativar',
					name: 'page-conta-anuncio-desativar',
					component: () => import('@/views/pages/site/conta/Anuncio/Desativar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Desativar Anúncio",
					}
				},
				{
					path: '/conta/anuncios/reativar',
					name: 'page-conta-anuncio-lista-reativar',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaReativar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Reativar Anúncios",
					}
				},
				{
					path: '/conta/anuncio/:id/reativar',
					name: 'page-conta-anuncio-reativar',
					component: () => import('@/views/pages/site/conta/Anuncio/Reativar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Reativar Anúncio",
					}
				},
				{
					path: '/conta/anuncios/eliminar',
					name: 'page-conta-anuncio-lista-eliminar',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaEliminar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Eliminar Anúncios",
					}
				},
				{
					path: '/conta/anuncio/:id/eliminar',
					name: 'page-conta-anuncio-eliminar',
					component: () => import('@/views/pages/site/conta/Anuncio/Eliminar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Eliminar Anúncio",
					}
				},

				{
					path: '/conta/anuncios/modificar-audio',
					name: 'page-conta-anuncio-lista-modificar-audio',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaModificarAudio.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Modificar Áudios",
					}
				},
				{
					path: '/conta/anuncio/:id/modificar-audio',
					name: 'page-conta-anuncio-modificar-audio',
					component: () => import('@/views/pages/site/conta/Anuncio/ModificarAudio.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Modificar Áudio do Anúncio",
					}
				},
				{
					path: '/conta/anuncios/modificar-video',
					name: 'page-conta-anuncio-lista-modificar-video',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaModificarVideo.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Modificar Vídeos",
					}
				},
				{
					path: '/conta/anuncio/:id/modificar-video',
					name: 'page-conta-anuncio-modificar-video',
					component: () => import('@/views/pages/site/conta/Anuncio/ModificarVideo.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Modificar Vídeo do Anúncio",
					}
				},
				{
					path: '/conta/anuncios/modificar-foto',
					name: 'page-conta-anuncio-lista-modificar-foto',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaModificarFoto.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Modificar Fotos",
					}
				},
				{
					path: '/conta/anuncio/:id/modificar-foto',
					name: 'page-conta-anuncio-modificar-foto',
					component: () => import('@/views/pages/site/conta/Anuncio/ModificarFoto.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Modificar Fotos do Anúncio",
					}
				},
				{
					path: '/conta/anuncios/subida-automatica',
					name: 'page-conta-anuncio-lista-subida-automatica',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaSubidaAutomatica.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Subir Automático",
					}
				},
				{
					path: '/conta/anuncio/:id/subida-automatica',
					name: 'page-conta-anuncio-subida-automatica',
					component: () => import('@/views/pages/site/conta/Anuncio/SubidaAutomatica.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Subir Anúncio Automaticamente",
					}
				},
				{
					path: '/conta/anuncio/:id/subida-automatica-pagar/:id_pedido',
					name: 'page-conta-anuncio-subida-automatica-pagar',
					component: () => import('@/views/pages/site/conta/Anuncio/SubidaAutomaticaPagar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Subir Anúncio Automaticamente",
					}
				},
				{
					path: '/conta/anuncios/subida-manual',
					name: 'page-conta-anuncio-lista-subida-manual',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaSubidaManual.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Subir Manual",
					}
				},
				{
					path: '/conta/anuncio/:id/subida-manual',
					name: 'page-conta-anuncio-subida-manual',
					component: () => import('@/views/pages/site/conta/Anuncio/SubidaManual.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Subir Anúncio Manualmente",
					}
				},
				{
					path: '/conta/anuncios/subidas-realizadas',
					name: 'page-conta-anuncio-lista-subidas-realizadas',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaSubidasRealizadas.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Subidas Realizadas",
					}
				},
				{
					path: '/conta/anuncios/historia-top',
					name: 'page-conta-anuncio-lista-historia-top',
					component: () => import('@/views/pages/site/conta/Anuncio/ListaHistoriaTop.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Histórias TOP",
					}
				},
				{
					path: '/conta/anuncio/:id/historia-top',
					name: 'page-conta-anuncio-historia-top',
					component: () => import('@/views/pages/site/conta/Anuncio/HistoriaTop.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Anúncio História TOP",
					}
				},
				{
					path: '/conta/anuncio/:id/detalhe',
					name: 'page-conta-anuncio-detalhe',
					component: () => import('@/views/pages/site/conta/Anuncio/Detalhe.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Gerenciar Anúncio",
					}
				},
				{
					path: '/conta/saldo',
					name: 'page-conta-saldo',
					component: () => import('@/views/pages/site/conta/Saldo/Saldo.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Saldo",
					}
				},
				{
					path: '/conta/colocar-saldo',
					name: 'page-conta-colocar-saldo',
					component: () => import('@/views/pages/site/conta/Saldo/ColocarSaldo.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Colocar Saldo",
					}
				},
				{
					path: '/conta/colocar-saldo/:id',
					name: 'page-conta-colocar-saldo-pagar',
					component: () => import('@/views/pages/site/conta/Saldo/PagarSaldo.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Colocar Saldo Pagar",
					}
				},
				{
					path: '/conta/disponiveis',
					name: 'page-conta-disponivel',
					component: () => import('@/views/pages/site/conta/Disponivel/Disponivel.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Disponível Agora",
					}
				},
				{
					path: '/conta/disponiveis-historico',
					name: 'page-conta-disponivel-historico',
					component: () => import('@/views/pages/site/conta/Disponivel/Historico.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Histórico de Disponível Agora",
					}
				},
				{
					path: '/conta/comprar-disponiveis',
					name: 'page-conta-colocar-disponivel',
					component: () => import('@/views/pages/site/conta/Disponivel/Comprar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Comprar Disponível Agora",
					}
				},
				{
					path: '/conta/comprar-disponiveis/:id',
					name: 'page-conta-colocar-disponivel-pagar',
					component: () => import('@/views/pages/site/conta/Disponivel/Pagar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Comprar Disponível Agora Pagar",
					}
				},
				{
					path: '/conta/anuncio/:id/disponivel-agora',
					name: 'page-conta-anuncio-disponivel-agora',
					component: () => import('@/views/pages/site/conta/Disponivel/DisponivelUsar.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Anúncio Disponível Agora",
					}
				},
				{
					path: '/conta/anuncios/disponiveis-historico',
					name: 'page-conta-anuncio-disponivel-historico',
					component: () => import('@/views/pages/site/conta/Disponivel/HistoricoUsado.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Histórico de Disponível Agora Usados",
					}
				},
				{
					path: '/conta/pedido',
					name: 'page-conta-pedido',
					component: () => import('@/views/pages/site/conta/Pedido.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Pedido",
					}
				},
				{
					path: '/conta/trocar-senha',
					name: 'page-conta-trocar-senha',
					component: () => import('@/views/pages/site/conta/TrocarSenha.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Trocar Senha",
					}
				},
				{
					path: '/conta/senha-alterada',
					name: 'page-conta-senha-alterada',
					component: () => import('@/views/pages/site/conta/SenhaAlterada.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Senha Alterada",
					}
				},
				{
					path: '/conta/receber-mensagens',
					name: 'page-conta-receber-mensagens',
					component: () => import('@/views/pages/site/conta/ReceberMensagens.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("editor").or("admin").generate(),
						title: "Conta - Receber Mensagens",
					}
				},

				/*
				https://www.photoacompanhantes.com/homens/aguas-de-sao-pedro/fa%C3%A7o-o-que-sua-imagina%C3%A7ao-alcan%C3%A7ar-o-extremo-da-satisfa%C3%A7ao-id-egmrg
				https://www.photoacompanhantes.com/acompanhantes/guaruja/putona-ultimos-dias-so-50-meia-local-discreto-enseada-id-hy838
				https://www.photoacompanhantes.com/videochamadas-sexting-mulheres/brasil/estou-disponivel-para-voce-chamada-a-partir-de-15-reais-id-dtkpv
				https://www.photoacompanhantes.com/massagens-eroticas-mulheres/sao-paulo/vila-olimpia/estou-com-promo%C3%A7ao-essa-semana-atendimento-excelente-id-n2pf4
				*/
				/*->where('categoria', '[0-9a-zA-Z]+')
				->where('sexo', '[0-9a-zA-Z]+')
				->where('estado', '[0-9a-zA-Z]+')
				->where('cidade', '[0-9a-zA-Z]+')
				->where('id_anuncio', '.*\-id\-[0-9a-zA-Z]+');
				$router->get('{categoria}/{sexo}/{estado}/{cidade}/{id_anuncio}', array_merge($adminRouterOptions, [*/
				{
					path: "/:id_anuncio(.*\\-id\\-[0-9a-zA-Z]+)",
					name: 'page-anuncio-detalhe-one',
					component: () => import('@/views/pages/site/Anuncio.vue'),
					meta: {
						rule: new AclRule("public").generate(),
						title: "Anúncio",
					}
				},
				/*{
					path: "/:categoria([0-9a-zA-Z]+)/:sexo([0-9a-zA-Z]+)/:estado([0-9a-zA-Z]+)/:cidade([0-9a-zA-Z]+)/:id_anuncio(.*\\-id\\-[0-9a-zA-Z]+)",
					name: 'page-anuncio-detalhe-one',
					component: () => import('@/views/pages/site/Anuncio.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("public").generate(),
						title: "Conta - Receber Mensagens",
					}
				},
				{
					path: '/:categoria([0-9a-zA-Z]+)/:estado([0-9a-zA-Z]+)/:cidade([0-9a-zA-Z]+)/:id_anuncio(.*\\-id\\-[0-9a-zA-Z]+)',
					name: 'page-anuncio-detalhe-two',
					component: () => import('@/views/pages/site/Anuncio.vue'),
					meta: {
						authRequired: true,
						rule: new AclRule("public").generate(),
						title: "Conta - Receber Mensagens",
					}
				},*/
				/*{
					path: '*',
					name: 'page-pesquisa',
					//component: () => import('@/views/pages/site/Site.vue'),
					component: () => import('@/views/pages/site/SitePesquisa.vue'),
					meta: {
						rule: new AclRule("public").generate(),
					}
				},*/
				{
					path: '*',
					name: 'page-index',
					component: () => import('@/views/pages/site/Site.vue'),
					meta: {
						rule: new AclRule("public").generate(),
					}
				},
			]
		},
		{
			path: '*',
			redirect: '/pages/error-404'
		}
	],
});

let startRouter = new Promise((resolve) => {
	router.start = resolve;
});
startRouter.pending = true;

router.isBusy = false;
router.afterEachLoadDone = null;
router.previousRoute = null;
router.previousRouteKeep = null;
router.lastCheckLoggedUser = null;

window.addEventListener('pageshow', (event) => {
	if (event.persisted) {
		console.log('THIS PAGE WAS RESTORED FROM THE BFCACHE.');
	} else {
		console.log('THIS PAGE WAS LOADED NORMALLY.', router.currentRoute ? router.currentRoute.name : null);
	}
});
/*window.addEventListener('popstate', (event) => {
	console.log('POPSTATE');
	console.log(
		`location: ${window.document.location}, state: ${JSON.stringify(event.state)}`,
	);
});*/

router.afterEach((to, from) => {
	if (to && to.meta && to.meta.title) {
		document.title = to.meta.title;
	} else if (router &&
		router.app &&
		router.app.siteNome
	) {
		document.title = router.app.siteNome;
	}
	/*const appLoading = document.getElementById('loading-bg');
	if (appLoading) {
		appLoading.style.display = "none";
	}*/

	router.previousRoute = from;
	router.previousRouteKeep = from;
	let appLoading = document.getElementById("loading-bg");
	if (appLoading) {
		console.log("ROUTER AFTER EACH LOAD DONE");
		appLoading.style.display = "none";
		router.isBusy = false;
		//router.afterEachLoadDone = performance.mark("routerAfterEachLoadDoneStart");
	}
});

router.beforeEach(async function (to, from, next) {
	console.log("ROUTER BEFORE EACH");
	router.isBusy = true;
	if (startRouter.pending) {
		console.log("ROUTER BEFORE EACH WAITING");
		await startRouter; // wait until 'start' called
		startRouter.pending = false;
		console.log("ROUTER BEFORE EACH RELEASED");
	}

	if (to.meta.authRequired) {
		if (!router.app.$store.getters.isUserLoggedIn) {
			console.log('ROUTER NOT LOGGED');
			router.app.$store.commit("auth/REMOVE_BEARER");
			router.app.$store.commit("REMOVE_USER_INFO");
			router.app.$store
				.dispatch("auth/refreshJWTToken", {
					token: null,
				})
				.then((response) => {
					setTimeout(function () {
						document.location.href = "/conta/entrar";
					}, 1500);
				})
				.catch((error) => {
					setTimeout(function () {
						document.location.href = "/conta/entrar";
					}, 1500);
				});
			return;
		} else {
			router.app.$store.commit("auth/SET_BEARER", router.app.$store.state.AppActiveUser.contaToken);
			router.app.$acl.change(router.app.$store.state.AppActiveUser.userRole);
			var now = new Date();
			if ((
				!router.lastCheckLoggedUser ||
				router.app.$moment(now).diff(router.lastCheckLoggedUser) > themeConfig.checkLoggedUserInterval
			)
				&&
				!(await router.app.$store
					.dispatch("auth/refreshJWTToken", {
						token: router.app.$store.state.AppActiveUser.contaToken,
					})
					.then((response) => {
						router.lastCheckLoggedUser = now;
						return true;
					})
					.catch((error) => {
						return false;
					}))
			) {
				document.location.href = "/conta/entrar";
				return;
			}
		}
	}
	return next();
});

export default router;
